import { Draft, produce } from 'immer';

import {
  CONTRACT_SETUP__DOCUMENT_AUTHENTICATIONS_FETCH_REQUEST,
  CONTRACT_SETUP__DOCUMENT_AUTHENTICATIONS_FETCH_SUCCESS,
  CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_REQUEST,
  CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_SUCCESS,
  CONTRACT_SETUP_ALL_STATE_CLEAR,
  CONTRACT_SETUP_BY_DRAFT_REQUEST,
  CONTRACT_SETUP_BY_DRAFT_SUCCESS,
  CONTRACT_SETUP_PARTICIPANT_AUTHENTICATION_CHANGE,
} from '@app/store/actionTypes';
import {
  ContractSetupAction,
  contractSetupSetParticipants,
} from '@app/store/contract-setup/actions';
import MeansType from '@app/store/MeansType';

export interface DigitalCertificateState {
  [id: string]: {
    bizNumber?: string;
    companyName?: string;
  };
}

const initialState: DigitalCertificateState = {};

export const DIGITAL_CERTIFICATE_RESTRICTED_MEANS = [MeansType.PHONE, MeansType.IN_PERSON];

const reducer = produce((draft: Draft<DigitalCertificateState>, action: ContractSetupAction) => {
  switch (action.type) {
    case CONTRACT_SETUP_ALL_STATE_CLEAR:
    case CONTRACT_SETUP_BY_DRAFT_REQUEST:
    case CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_REQUEST:
      return initialState;
    case CONTRACT_SETUP__DOCUMENT_AUTHENTICATIONS_FETCH_REQUEST: {
      Object.keys(draft).forEach((participantId) => {
        draft[participantId] = {};
      });
      return draft;
    }
    case CONTRACT_SETUP__DOCUMENT_AUTHENTICATIONS_FETCH_SUCCESS: {
      const { participantAuthentications } = action.payload;
      participantAuthentications.forEach((participantAuthentication) => {
        const { digitalCertificate, participantId } = participantAuthentication;
        if (digitalCertificate && participantId) {
          draft[participantId].bizNumber = digitalCertificate.bizNumber;
          draft[participantId].companyName = digitalCertificate.companyName;
        }
      });
      return draft;
    }
    case CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_SUCCESS: {
      const { participants } = action.payload;
      participants.forEach((participant) => {
        const { participantId } = participant;
        draft[participantId] = {};
      });
      return draft;
    }
    case CONTRACT_SETUP_PARTICIPANT_AUTHENTICATION_CHANGE: {
      const { digitalCertificate, participantId } = action.payload;
      draft[participantId] = {
        bizNumber: digitalCertificate.bizNumber,
        companyName: digitalCertificate.companyName,
      };
      return draft;
    }
    case contractSetupSetParticipants.type: {
      const result: DigitalCertificateState = {};

      action.payload.forEach(({ participantId, meansType }) => {
        if (
          DIGITAL_CERTIFICATE_RESTRICTED_MEANS.includes(meansType) ||
          draft[participantId] == null
        ) {
          result[participantId] = {};
          return;
        }

        result[participantId] = draft[participantId];
      });

      return result;
    }
    case CONTRACT_SETUP_BY_DRAFT_SUCCESS: {
      const { participants } = action.payload;
      participants.forEach(({ id, verification }) => {
        if (verification.dCert) {
          draft[id] = {
            companyName: verification.dCert.name,
            bizNumber: verification.dCert.bizNumber,
          };
        } else {
          draft[id] = {};
        }
      });
      return draft;
    }

    default:
      return draft;
  }
}, initialState);

export default reducer;
